module.exports = ".tdStatus {\n  font-weight: 500; }\n\n.tdStatusTitulo {\n  font-weight: 500;\n  font-size: 19px;\n  text-decoration: underline; }\n"